export default class RangeSlider {
    constructor (rangeElement) {
        this.rangeElement = rangeElement.querySelector('input');
        this.valueElement = rangeElement.querySelector('[data-range-indicator]');
        this.rangeElement.addEventListener('input', this.updateSlider.bind(this))

        this.updateSlider()
    }
  
    generateBackground() {   
        return `background: linear-gradient(to right, #008e9f, #008e9f ${this.percentage}%, rgba(83, 83, 83, 0.2) ${this.percentage}%, rgba(83, 83, 83, 0.2) 100%)`;
    }
  
    updateSlider (newValue) {
        this.percentage = (this.rangeElement.value - this.rangeElement.min) / (this.rangeElement.max - this.rangeElement.min) * 100;
        
        this.rangeElement.style = this.generateBackground();
        this.updateIndicator();
    }

    updateIndicator() {
        this.valueElement.innerHTML = this.rangeElement.value +' °C';

        const range = this.rangeElement.max - this.rangeElement.min;
        const position = ((this.rangeElement.value - this.rangeElement.min) / range) * 100;
        const positionOffset = Math.round(47 * position / 100) - (47 / 2);

        this.valueElement.style.left = `calc(${position}% - ${positionOffset}px)`;
    }
}